import { render, staticRenderFns } from "./PolicyRules.vue?vue&type=template&id=83060628&"
import script from "./PolicyRules.vue?vue&type=script&lang=js&"
export * from "./PolicyRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports